import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  Toolbar,
  SaveButton,
  DeleteButton,
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import WithProps from "../Custom/WithProps";
import VideoUploadInput from "./VideoUploadInput";
import TagsInput from "./TagsInput";
import {
  validateTitle,
  validatePriority,
  validateVideoPath,
  validateTags,
  apiTagsToRows,
} from "./util";

const useStyles = makeStyles(() => ({
  container: { width: "90%", margin: "auto" },
}));

const EditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
    <DeleteButton undoable={false} style={{ marginLeft: "auto" }} />
  </Toolbar>
);

const TrainingVideoEdit = props => {
  const classes = useStyles();

  return (
    <Edit {...props} undoable={false}>
      <WithProps>
        {({ record, ...rest }) => (
          <SimpleForm
            {...rest}
            record={
              record
                ? { ...record, tags: apiTagsToRows(record.tags) }
                : record
            }
            redirect="list"
            toolbar={<EditToolbar />}
          >
            <Grid container spacing={2} className={classes.container} justify="space-between">
              <Grid item xs={12} md={6}>
                <TextInput source="title" label="Title" validate={validateTitle} fullWidth />
              </Grid>
              <Grid item xs={12} md={6}>
                <NumberInput source="priority" label="Priority" validate={validatePriority} fullWidth />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput source="summary" label="Summary" multiline fullWidth />
              </Grid>
              <Grid item xs={12} md={6}>
                <BooleanInput source="active" label="Active" />
              </Grid>
              <Grid item xs={12}>
                <TextInput source="description" label="Description" multiline rows={4} fullWidth />
              </Grid>
              <Grid item xs={12}>
                <TagsInput source="tags" label="Tags" validate={validateTags} />
              </Grid>
              <Grid item xs={12}>
                <VideoUploadInput source="video_file_path" label="Video" validate={validateVideoPath} />
              </Grid>
            </Grid>
          </SimpleForm>
        )}
      </WithProps>
    </Edit>
  );
};

export default TrainingVideoEdit;
